const defaultProps = [];

export default defaultProps;
